import axios from 'axios'
import {rootUrl} from '@/common/js/config'
import {httpGet,httpPost} from "@/common/js/util";

export function login (userInfo) {
  const url = rootUrl.loginURL
  const params = {
    loginName:userInfo.loginname,
    password:userInfo.password,
    modules:userInfo.modules
  }
  return httpPost(url,params)
}

export function logout () {
  const url = rootUrl.logoutURL
  return httpPost(url)
}

export function compareValidareCode (validareCode) {
  const url = rootUrl.compareValidareCode
  const params = {
    validareCode:validareCode
  };
  return httpPost(url,params)
}

export function checkLogin () {
  const url = rootUrl.checkLogin
  return httpPost(url)
}

export function getStoreUrl () {
  const url = rootUrl.getStoreUrl
  return httpPost(url)
}


export function saveUserProtocol(params) {
  return httpPost(rootUrl.saveUserProtocol,params)
}

export function getSSOConfig(params ={}) {
  return httpPost(rootUrl.getSSOConfig,params)
}


// WEBPACK FOOTER //
// ./src/api/login-api.js